import type { LegalDoc } from '@gjl/site-kit'
import { LegalArticle } from '@gjl/site-kit'

/**
 * Renders a generated `LegalDoc` through Fairmeadow's own typography.
 *
 * The COPY and the render STRUCTURE both come from `@gjl/site-kit`; only the
 * hero band and the body type scale are bespoke, which is the same
 * split every other site in the estate uses. Deliberately NOT a bespoke layout:
 * a legal page that drifts from the shared one is a legal page whose corrections
 * stop arriving.
 *
 * No `blocks` prop. Fairmeadow has no CMS org, so there is no client-authored
 * body that could override the generated document — see `../legal-options.ts`.
 */
export function LegalPage({ doc }: { doc: LegalDoc }) {
  return (
    <div className="bg-background text-foreground">
      <LegalArticle
        doc={doc}
        hero={
          <section className="border-border border-b">
            <div className="mx-auto max-w-5xl px-5 pt-14 pb-12 md:px-8 md:pt-20 md:pb-16">
              <h1 className="text-fluid-h1 text-navy mb-6 max-w-4xl">{doc.title}</h1>
              <p className="text-fluid-body-lg text-muted-foreground max-w-2xl">{doc.intro[0]}</p>
            </div>
          </section>
        }
        classes={{
          section: 'px-4 py-16 md:py-24',
          sectionsWrap: 'mx-auto max-w-3xl space-y-12',
          intro: 'text-muted-foreground mb-5 text-[1.05rem] leading-[1.85]',
          heading: 'text-foreground mb-3 text-2xl font-bold sm:text-[1.65rem]',
          body: 'text-muted-foreground mb-4 text-[1.05rem] leading-[1.85] last:mb-0',
          meta: 'border-border text-muted-foreground/70 mx-auto mt-16 max-w-3xl border-t pt-6 text-sm',
        }}
      />
    </div>
  )
}
